const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/pages/InvoicePage/InvoiceListRow.tsx';
import { useTheme } from '@mui/material/styles';
import { css } from '@emotion/css';
import { useMemo, useState } from 'react';
import { Report } from '@cistec/common_web/defs/kisim';
import { KISIM_STD_DATE_FORMAT, KISIM_TIME_FORMAT } from '@cistec/common_web/defs/generalDefs';
import moment from 'moment/moment';
import { InvoicePDFDialog } from './InvoicePDFDialog';

interface Props {
    invoice: Report;
}

function useCSSClasses() {
    const theme = useTheme();
    return useMemo(
        () => ({
            invoiceListRowCSS: css`
                cursor: pointer;
                padding: 0 ${theme.spacing(1)};
                height: ${theme.spacing(4)};
                display: flex;
                align-items: center;

                > *:not(:first-child) {
                    margin-left: ${theme.spacing(2)};
                }

                .date {
                    flex: none;
                }

                .title {
                    flex: auto;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    overflow: hidden;
                }
            `,
        }),
        [theme]
    );
}

export const InvoiceListRow = (props: Props) => {
    const classes = useCSSClasses();
    const { invoice } = props;
    const [showDocumentDialog, setShowDocumentDialog] = useState(false);

    const handleClick = () => {
        setShowDocumentDialog(true);
    };

    const handleDialogClose = () => {
        setShowDocumentDialog(false);
    };

    const date = moment(invoice.DAT, KISIM_TIME_FORMAT).format(KISIM_STD_DATE_FORMAT);
    const text = invoice.NAME;

    const dateElement = <div className="date">{date}</div>;
    const titleElement = <div className="title">{text}</div>;

    return (
        <>
            {showDocumentDialog ? <InvoicePDFDialog invoice={invoice} onClose={handleDialogClose} /> : null}
            <div className={classes.invoiceListRowCSS} onClick={handleClick}>
                {dateElement}
                {titleElement}
            </div>
        </>
    );
};
